import { get as getConstants } from '@lumapps/constants';

import type { GetURLOptions } from '../api';
import { AppId, LOCAL_PORT_CONFIGURATION } from '../constants';
import { OptionalAppRoute } from '../types';
import { addLocationOriginToUrl } from './addLocationOriginToUrl';
import { createRelativeUrl } from './createRelativeUrl';
import { getBaseUrl } from './getBaseUrl';

const constants = getConstants();

/**
 * Returns a URL that takes into account the customer and instance slugs
 * @param route - route used to create the url
 * @deprecated use `getUrl` from `useRouter` to properly adapt the URL to the app context
 */
export const createUrl = (route: OptionalAppRoute, options?: GetURLOptions) => {
    const { instanceSlug } = route;
    const hasCustomInstanceSlug = Boolean(instanceSlug);
    const isExternal = route.appId === AppId.external;
    const baseUrl = isExternal ? '' : getBaseUrl(window.location.pathname, !hasCustomInstanceSlug);
    const customInstancePart = !isExternal && hasCustomInstanceSlug ? `/${instanceSlug}` : '';
    const url = `${baseUrl}${customInstancePart}${createRelativeUrl(route)}`;

    /**
     * This checks if we are currently developing locally and the application target is different
     * from the current application id, it means that we are trying to create a link towards another
     * application. In this scenario, we need to create a different URL with a different port, since they
     * are separate applications hosted in different ports.
     */
    if (
        route.appId &&
        constants.isDev &&
        !constants.isIntegrationTest &&
        route.appId !== constants.applicationId &&
        !isExternal
    ) {
        const portForLocalTargetApp = LOCAL_PORT_CONFIGURATION[route.appId];
        return `http://localhost:${portForLocalTargetApp}${url}`;
    }

    if (options?.absolute === 'location-based') {
        return addLocationOriginToUrl(url);
    }

    return url;
};
